module.exports = __webpack_public_path__ + "img/raketa.888a5808.png";